import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const RsTableRow = forwardRef(({ className, children }, ref) => {
  return (
    <tr ref={ref} className={cn('table__row c-els-table__row', className)}>
      {children}
    </tr>
  );
});

RsTableRow.propTypes = {
  className: PropTypes.string,
};

export default RsTableRow;
